<template>

    <dx-load-panel class="loading-panel-container" :position="position"
                   :visible.sync="isLoading"
                   :show-indicator="showIndicator"
                   :show-pane="showPane"
                   :shading="shading"
                   v-bind="customProps"
                   shading-color="rgba(0,0,0,0.4)"
                   :indicator-src="indicatorSrc"
                   width="350" height="200" />
</template>

<script>
    import { DxLoadPanel } from 'devextreme-vue/load-panel';
    import { eventBus } from '@/index';
    import indicator from '@/Common/Content/loader.gif';

    export default {
        name: 'loading-panel',
        components: {

            DxLoadPanel
        },
        data() {
            return {
                isLoading: false,
                position: { of: '#mainApp' },
                shading: true,
                showPane: true,
                showIndicator: true,
                indicatorSrc: indicator,
                customProps: {},
            }
        },
        created() {
            eventBus.$on('showing-load-panel', (l, customMessage) => { this.isLoading = l; this.customProps.message = customMessage });
        },
        beforeDestroy() {
            eventBus.$off('showing-load-panel');
        }
    }

</script>

<style>
    .loading-panel-container .dx-loadindicator {
        width: 100px;
        height: 100px;
    }
</style>